import Metrics from './Metrics.container'

export default Metrics
